import { cn } from '@theprintbar/shared';
import { useField } from 'remix-validated-form';
import { FieldProps, useOutsideForm } from '../index';

export interface CheckboxProps extends FieldProps<HTMLInputElement> {
	trailingCheck?: boolean;
	inputClassName?: string;
	labelClassName?: string;
}

export function Checkbox({
	children,
	name,
	trailingCheck,
	label,
	fieldRef,
	inputClassName,
	labelClassName,
	defaultChecked,
	className,
	outsideForm,
	...props
}: CheckboxProps) {
	const { error, getInputProps } = outsideForm ? useOutsideForm(name) : useField(name);

	const LabelEl = (
		<label htmlFor={name} className={cn('text-xs font-normal text-blue w-full', trailingCheck ? 'mr-2.5' : 'ml-2.5', labelClassName)}>
			{label}
		</label>
	);

	return (
		<div className={cn('relative flex items-center mb-4', className)}>
			{!!trailingCheck && LabelEl}
			<input
				aria-describedby={`${name}-error`}
				ref={fieldRef}
				defaultChecked={defaultChecked}
				className={cn('focus:ring-blue h-4 w-4 text-blue border-blue bg-transparent rounded', inputClassName)}
				{...getInputProps({
					...props,
					id: name,
					type: 'checkbox',
				})}
			/>
			{!trailingCheck && LabelEl}
			{error && (
				<span id={`${name}-error`} className="absolute left-0 -bottom-5 text-xs text-red-600">
					{error}
				</span>
			)}
		</div>
	);
}
